<template>
    <div class="notfound-container">
        <img class="notfound-img" :src="notFoundImg" />
        <p class="notfound-tips">您访问的页面走丢了</p>
    </div>
</template>
<script>
import notFoundImg from "@/assets/images/404.webp";

export default {
	name: "AppNotfound",
	data() {
		return {
			notFoundImg,
		};
	},
};
</script>
<style lang="less" scoped>
.notfound {
    &-container {
        text-align: center;
        height: 100%;
    }

    &-img {
        display: block;
        margin: 0 auto;
        height: 80%;
    }

    &-tips {
        font-size: 26px;
        color: #ccc;
        font-style: italic;
        font-family: cursive;
    }
}
</style>
